module.exports = __webpack_public_path__ + "static/media/f4.977f3e61.png";